// Lab time limits and the guest sign-up prompt.
// Plain functions with no React or browser imports so node:test can drive them
// (spec/javascript/guest_limit.test.mjs, run by spec/requests/guest_lab_limit_spec.rb).

// Server thresholds in seconds (experiments_helper.rb time_thresholds). `??`, not `||`: the server sends
// tertiary 0 for guests (hard limit from the start), and 0 must not fall back to 10 minutes.
export const labTimeThresholds = (timeThresholds) => {
  const t = timeThresholds || {};
  return {
    primary: t.primary ?? 1 * 60,
    secondary: t.secondary ?? 2 * 60,
    tertiary: t.tertiary ?? 10 * 60
  };
};

// The tertiary 0 is a guest-only rule. A guest who signs in from another tab is updated in place (no reload), and
// the guest's reached hard limit must not follow them; their own 10 minutes start on the next page load.
export const guestHardLimitReleased = ({ tertiaryThreshold, user }) => tertiaryThreshold === 0 && !!user;

// ActionMessage is the guest sign-up prompt. When it goes from hidden to shown for a guest, say why:
// 'locked_feature' when the engine reported a locked feature (show_limitation raised `limited`),
// otherwise 'lab_load' (initialGuestShow on mount). Returns null when no guest prompt opened.
export const guestPromptOpenSource = ({ user, wasShown, isShown, limitedRose }) => {
  if (user) return null;
  if (wasShown || !isShown) return null;
  return limitedRose ? 'locked_feature' : 'lab_load';
};

export const trackGuestLimitShown = (gtag, source) => {
  if (!source || typeof gtag !== 'function') return false;
  try {
    gtag('event', 'guest_limit_shown', { source });
  } catch (e) {
    // Analytics failures are not the user's problem
  }
  return true;
};
